import { Injectable } from "@angular/core";
import { Asset, Contact, ContactField } from "@models";
import { ContactService } from "@main-services/contact.service";
import { CryptocoinService } from "@main-services/currency";

@Injectable()
export class ContactFieldService {
	constructor(
		private contactService: ContactService,
		private cryptoCoinService: CryptocoinService
	) {}

	public getRecentContactFields(asset: Asset): ContactField[] {
		const resultedCFs: ContactField[] = [];
		this.contactService.contacts.forEach((contact: Contact) => {
			contact.getFieldsForRecent().forEach((contactField: ContactField) => {
				if (
					contactField.getValue().length > 0 &&
					(contact.isUser() ||
						(!contact.isUser() &&
							(contactField.getType() === "email" ||
								contactField.getType().indexOf(asset.getSymbol(true)) > -1)))
				) {
					if (contactField.getType() === "email") {
						const duplicate = resultedCFs.find((f) => f.getValue() === contactField.getValue());
						if (duplicate) {
							return;
						}
					}
					resultedCFs.push(contactField);
				}
			});
		});
		return resultedCFs
			.filter((f) => {
				if (f.lastUsed() <= 0) {
					return false;
				}
				if (this.cryptoCoinService.list.some((c) => c.getSymbol(true) === f.getType().substring(0, 3))) {
					return f.getType().substring(0, 3) === asset.getSymbol(true);
				}

				if (this.cryptoCoinService.list.some((c) => c.getSymbol(true) === f.getType().substring(0, 4))) {
					return f.getType().substring(0, 4) === asset.getSymbol(true);
				}

				if (this.cryptoCoinService.list.some((c) => c.getSymbol(true) === f.getType().substring(0, 5))) {
					return f.getType().substring(0, 5) === asset.getSymbol(true);
				}

				return f.getType().length >= 1;
			})
			.sort((field1, field2) => field2.lastUsed() - field1.lastUsed())
			.slice(0, 3);
	}

	public getRecentContactDescription(field: ContactField): string {
		if (this.isCurrentContactField(field)) {
			const hasValueMatch: ContactField[] = this.matchingContact(field)[0]
				.getFields(false, true)
				.filter((f) => f.getValue() === field.getValue());
			if (field.getType() === "email") {
				return "email_recent_users";
			}

			if (hasValueMatch[0] && hasValueMatch[0].getName().length > 0) {
				return hasValueMatch[0].getName();
			}
			return "recent_crypto_address";
		}
		if (field.getType() === "email") {
			return "new_email_recent_users";
		}
		return "new_recent_crypto_address";
	}

	public isCurrentContactField(field: ContactField): boolean {
		return this.matchingContact(field).length > 0;
	}

	public matchingContact(field: ContactField): Contact[] {
		const activeContacts: Contact[] = this.contactService.contacts.filter((f) => !f.isDeleted());
		return activeContacts.filter((f) => {
			const fields: ContactField[] = f.getFields(false, true);
			return fields.some(
				(f) => f.getValue() === field.getValue() && f.getDestinationTag() === field.getDestinationTag()
			);
		});
	}
}
